/**
 * Meaningful Conversations API Service
 */

import { MC_API_URL } from '../config/api';

const BASE = `${MC_API_URL}/conversations/api`;

async function mcFetch(endpoint, options = {}) {
  const response = await fetch(`${BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || `Request failed: ${response.status}`);
  }
  return data.data;
}

// Cycles
export const getCycles = () => mcFetch('/cycles');
export const getCycleDetail = (id) => mcFetch(`/cycles/${id}`);
export const createCycle = (name, description, createdBy, endDate) =>
  mcFetch('/cycles', {
    method: 'POST',
    body: JSON.stringify({ name, description, created_by: createdBy, end_date: endDate })
  });

// Upload recipients
export const uploadRecipients = (cycleId, emails) =>
  mcFetch(`/cycles/${cycleId}/upload`, {
    method: 'POST',
    body: JSON.stringify({ emails })
  });

// Analytics
export const getAnalytics = () => mcFetch('/analytics');
export const getCycleAnalytics = (cycleId) => mcFetch(`/analytics/${cycleId}`);

// AI Insights
export const getCycleInsights = (cycleId) => mcFetch(`/analytics/${cycleId}/insights`);
export const generateCycleInsights = (cycleId) =>
  mcFetch(`/analytics/${cycleId}/insights/generate`, { method: 'POST' });

// My Surveys (authenticated user)
export const getMCSurveys = (email) => mcFetch(`/my-surveys?email=${encodeURIComponent(email)}`);

// MC Admin check (requires auth token)
export const checkIsMCAdmin = (accessToken) =>
  mcFetch('/users/me/is-mc-admin', {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });

// Public survey (by token)
export const getSurveyByToken = (token) => mcFetch(`/survey/${token}`);
export const submitSurveyResponse = (token, data) =>
  mcFetch(`/survey/${token}/respond`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
